import React from "react";
import Swiper from "../components/Swiper";

export default class Product extends React.Component {
  aStyle = {
    background: "top center no-repeat",
    cursor: "pointer",
    backgroundImage:
      "url(" + require("../assets/images/product/1-2103091645113K.jpg") + ")",
  };
  swiperMes = {
    slidesPerView: 3,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    className: "product_img",
    centeredSlides: true,
    centeredSlidesBounds: true,
  };

  swt = () => {
    let myhref = window.location.href;
    let swtlj =
      "http://plt.zoosnet.net/LR/Chatpre.aspx?id=PLT65467523&lng=cn&r=" +
      encodeURIComponent(document.referrer) +
      "&p=" +
      encodeURIComponent(myhref);
    window.open(swtlj, "_blank");
  };
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="content">
        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/hot.jpg")}
              alt="商务通"
            />
          </a>
        </div>

        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/13.jpg")}
              alt="商务通"
            />
          </a>
        </div>

        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/14.jpg")}
              alt="商务通"
            />
          </a>
        </div>

        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/15.jpg")}
              alt="商务通"
            />
          </a>
        </div>

        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/12.jpg")}
              alt="商务通"
            />
          </a>
        </div>
        <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/16.jpg")}
              alt="商务通"
            />
          </a>
        </div>
        {/* <div>
          <a onClick={this.swt}>
            <img
              src={require("../assets/images/product/hot.jpg")}
              alt="商务通"
            />
          </a>
        </div>

        <div>
          <a onClick={this.swt}>
            <img
             src={require("../assets/images/product/hot.jpg")}
              alt="商务通"
            />
          </a>
        </div> */}

        <div className="h80"></div>
      </div>
    );
  }
}
